document.addEventListener("DOMContentLoaded", () => {
    const backInStockURL = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=R3KzPL";
    const newsletterURL = "https://a.klaviyo.com/client/subscriptions/?company_id=R3KzPL";

    // Prüfe, ob die Produkt-ID verfügbar ist
    if (typeof productID === "undefined") {
        console.error("Produkt-ID ist nicht definiert");
        return;
    }


    document.getElementById("subscriptionForm").addEventListener("submit", async (event) => {
        event.preventDefault();

        const email = document.getElementById("email").value;
        const newsletterChecked = document.getElementById("newsletter").checked;

        // Payload für Back-in-Stock Subscription
        const backInStockPayload = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email,
                            },
                        },
                    },
                    channels: ["EMAIL"],
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$custom:::$default:::${productID}`, // Dynamische Produkt-ID
                        }
                    }
                }
            }
        };

        // Payload für Newsletter Subscription
        const newsletterPayload = {
            data: {
                type: "subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email,
                            },
                        },
                    },
                },
                relationships: {
                    list: {
                        data: {
                            type: "list",
                            id: "UJf9vA",
                        }
                    }
                }
            }
        };

        const headers = {
            "Content-Type": "application/json",
            "revision": "2024-02-15",
            "X-Klaviyo-Onsite": "1",
        };

        try {
            // Back-in-Stock Subscription
            const backInStockResponse = await fetch(backInStockURL, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(backInStockPayload),
            });

            if (!backInStockResponse.ok) {
                console.error("Back-in-Stock Subscription failed", await backInStockResponse.text());
            } else {
                //console.log("Back-in-Stock Subscription successful");
                document.getElementById("subscriptionForm").remove();
                document.querySelector("#subscription-success-message").style.display = "block"
            }

            // Newsletter Subscription (falls Checkbox ausgewählt)
            if (newsletterChecked) {
                const newsletterResponse = await fetch(newsletterURL, {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(newsletterPayload),
                });

                if (!newsletterResponse.ok) {
                    console.error("Newsletter Subscription failed", await newsletterResponse.text());
                } else {
                    //console.log("Newsletter Subscription successful");
                }
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    });
});
